module.exports = __webpack_public_path__ + "static/sinner-profile-3669ef540f5dc35fedd9d9cd8aeee7c7.jpg";